import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-trend-idicator-display',
  templateUrl: './trend-idicator-display.component.html',
  styleUrls: ['./trend-idicator-display.component.scss']
})
export class TrendIdicatorDisplayComponent implements OnInit {
  @Input() indicatorName!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
